import styled from "styled-components";
import Skills from "./Skills";

const AboutMe = ({ t }) => {
  return (
    <StyledWrapper className="wrapper">
      <StyledContent className="content">
        <h1> {t("o_mnie")}</h1>
        <p>{t("o_mnie_p1")}</p>
        <p>{t("o_mnie_p2")}</p>
        <p>{t("o_mnie_p3")}</p>
        <Skills t={t}/>
      </StyledContent>
    </StyledWrapper>
  );
};

export default AboutMe;
const StyledWrapper = styled.div``;
const StyledContent = styled.div`
  background-color: #e9e9e9;
  padding: 2rem;
  h1 {
    font-size: 3rem;
  }
  p {
    padding: 1.6rem 0rem;
    font-size: 1.75rem;
  }
`;
